import * as React from "react"

const DetailItem = ({ item }) => {
  return (
    <div className="detailItem">
      <img
        src={item.image}
        alt={item.name}
      />
      <h3>{item.name}</h3>
      {item.description && (
        <p className="detailItem-description">{item.description}</p>
      )}
      {item.price && (
        <p className="detailItem-price">${item.price}</p>
      )}
      {item.price1 && (
        <p className="detailItem-price">${item.price1} {item.price1Text}</p>
      )}
      {item.price2 && (
        <p className="detailItem-price">${item.price2} {item.price2Text}</p>
      )}
    </div>
  )
}

export default DetailItem
